import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { Platform, PlatformKey } from '../models';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { MediaType } from '@app/core';

interface IPlatformSearchParameter {
  name?: string;
  delivery_control_type?: number;
  delivery_types?: number[];
  has_encrypt_key?: number;   // key未発行のプラットフォーム検索フラグ(0: key未発行検索、設定なし: 通常のプラットフォーム検索)
  is_allox_managed?: boolean; // Alloxで管理しているPF(true), Allox管理外PF(false)(Zeus,SledgeHammer)
}

@Injectable({ providedIn: 'root' })
export class PlatformService {

  private path = '/platforms';

  constructor(private http: AlloxApiService) { }

  public search(param: IPlatformSearchParameter = {}) {
    const query = Object.keys(param)
      .filter(k => param[k] != null)
      .reduce((prev, k) => prev += '&' + k + '=' + encodeURIComponent(param[k]), '')
      .replace('&', '?');
    return this.http.get<[]>(this.path + query).pipe(
      map(objs => objs.map(obj => new Platform(obj)))
    );
  }

  public fetchOnlySdk(){
    return this.search().pipe(
      map((platforms) => platforms.filter((platform) => platform.mediaType === MediaType.APP_SDK))
    );
  }

  public fetchOnlyTopicsURL(){
    return this.search().pipe(
      map((platforms) => platforms.filter((platform) => platform.hasTopics === true))
    );
  }

  public searchDistinct(param: IPlatformSearchParameter = {}) {
    const query = Object.keys(param)
      .filter(k => param[k] != null)
      .reduce((prev, k) => prev += '&' + k + '=' + encodeURIComponent(param[k]), '')
      .replace('&', '?');
    return this.http.get<[]>(this.path + '/distinct' + query).pipe(
      map(objs => objs.map(obj => new Platform(obj)))
    );
  }

  public fetch(id: number) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new Platform(obj))
    );
  }

  // key発行
  public post(item: PlatformKey): Observable<PlatformKey> {
    return this.http.post<PlatformKey>(this.path + '/' + item.platformId + '/keys').pipe(
      map(res => new PlatformKey(res))
    );
  }
}
